export default {"src":"/_next/static/media/partner28.09c49556.svg","height":70,"width":123,"blurWidth":0,"blurHeight":0};